export const AUDITOR_COMMENTS_COLUMN_LABELS = {
    YEAR: 'Year',
    AUDITOR_DETAILS: 'Auditor Details',
    DIRECTOR_COMMENTS: "Director's Comments",
};

export const AUDITOR_COMMENTS_DRAWER_TITLE = 'Auditor Comments';

export const QUALIFICATION_LABELS = {
    QUALIFIED: 'Qualified / Reservations / Adverse Remarks',
    NOT_QUALIFIED: 'No Qualified / Reservations / Adverse Remarks',
};

export const NO_DATA_LABEL = 'No Data Available';
